import { render, staticRenderFns } from "./PackageComparison.vue?vue&type=template&id=93af18f2&scoped=true"
import script from "./PackageComparison.vue?vue&type=script&lang=js"
export * from "./PackageComparison.vue?vue&type=script&lang=js"
import style0 from "./PackageComparison.vue?vue&type=style&index=0&id=93af18f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93af18f2",
  null
  
)

export default component.exports